module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 127);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@splunk/themes");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* reexport */ src_Button_Button; });

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(2);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "lodash"
var external_lodash_ = __webpack_require__(4);

// EXTERNAL MODULE: external "@splunk/ui-utils/i18n"
var i18n_ = __webpack_require__(5);

// EXTERNAL MODULE: external "@splunk/react-ui/Dropdown"
var Dropdown_ = __webpack_require__(19);

// EXTERNAL MODULE: external "@splunk/ui-utils/style"
var style_ = __webpack_require__(40);

// EXTERNAL MODULE: ./src/icons/CaretDown.tsx
var CaretDown = __webpack_require__(36);

// EXTERNAL MODULE: external "@splunk/react-icons/External"
var External_ = __webpack_require__(51);
var External_default = /*#__PURE__*/__webpack_require__.n(External_);

// EXTERNAL MODULE: ./src/icons/ThemedIcon.tsx
var ThemedIcon = __webpack_require__(7);

// EXTERNAL MODULE: ./src/icons/SVG.tsx
var SVG = __webpack_require__(6);

// CONCATENATED MODULE: ./src/icons/External.tsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }






function Prisma24(_ref) {
  var otherProps = _extends({}, _ref);

  return /*#__PURE__*/external_react_default.a.createElement(SVG["a" /* default */], _extends({
    viewBox: "0 0 24 24"
  }, otherProps), /*#__PURE__*/external_react_default.a.createElement("path", {
    d: "M3 4.10623C3 3.51257 3.47768 3.00623 4.09895 3.00623H7.49725C8.04954 3.00623 8.49725 3.45394 8.49725 4.00623C8.49725 4.55851 8.04954 5.00623 7.49725 5.00623H5V18.9937H18.9874V16.4964C18.9874 15.9441 19.4352 15.4964 19.9874 15.4964C20.5397 15.4964 20.9874 15.9441 20.9874 16.4964V19.8937C20.9874 20.5012 20.495 20.9937 19.8874 20.9937H4.1C3.49248 20.9937 3 20.5012 3 19.8937V4.10623ZM19.0002 6.42035L10.6109 14.8096C10.2204 15.2002 9.58722 15.2002 9.1967 14.8096C8.80618 14.4191 8.80618 13.7859 9.1967 13.3954L17.5859 5.00623H13.6592C13.1069 5.00623 12.6592 4.55851 12.6592 4.00623C12.6592 3.45394 13.1069 3.00623 13.6592 3.00623H19.5002C20.3287 3.00623 21.0002 3.6778 21.0002 4.50623V10.3117C21.0002 10.864 20.5525 11.3117 20.0002 11.3117C19.4479 11.3117 19.0002 10.864 19.0002 10.3117V6.42035Z",
    fill: "currentColor"
  }));
}

function External(props) {
  return /*#__PURE__*/external_react_default.a.createElement(ThemedIcon["a" /* default */], _extends({
    Enterprise: External_default.a,
    Prisma24: Prisma24
  }, props));
}
// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(3);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: external "@splunk/react-ui/ButtonSimple"
var ButtonSimple_ = __webpack_require__(43);
var ButtonSimple_default = /*#__PURE__*/__webpack_require__.n(ButtonSimple_);

// EXTERNAL MODULE: external "@splunk/themes"
var themes_ = __webpack_require__(0);

// CONCATENATED MODULE: ./src/Button/ButtonStyles.ts



var StyledIcon = external_styled_components_default.a.span.withConfig({
  displayName: "ButtonStyles__StyledIcon",
  componentId: "eqxqs2-0"
})(["display:flex;align-items:center;flex-shrink:0;font-size:", ";", ";"], Object(themes_["pick"])({
  enterprise: 'inherit',
  prisma: {
    comfortable: '21px',
    compact: '16px'
  }
}), Object(themes_["pickVariant"])('$isIconOnly', {
  "false": {
    enterprise: Object(external_styled_components_["css"])(["padding-right:3px;"]),
    prisma: Object(external_styled_components_["css"])(["padding-right:8px;"])
  }
}));
var StyledButtonSimple = external_styled_components_default()(ButtonSimple_default.a).withConfig({
  displayName: "ButtonStyles__StyledButtonSimple",
  componentId: "eqxqs2-1"
})(["text-align:center;vertical-align:middle;text-decoration:none;white-space:nowrap;flex-grow:1;min-width:0;max-width:100%;line-height:", ";min-height:", ";padding:", ";", " ", " &[data-inline]{display:inline-block;vertical-align:middle;", " [data-inline] + &{margin-bottom:0;", "}}"], themes_["variables"].lineHeight, themes_["variables"].inputHeight, Object(themes_["pick"])({
  enterprise: {
    comfortable: '5px 14px',
    compact: '2px 14px'
  },
  prisma: {
    comfortable: function comfortable(_ref) {
      var $hasPrismaIcon = _ref.$hasPrismaIcon;
      return $hasPrismaIcon ? '7px 18px' : '9px 18px';
    },
    compact: function compact(_ref2) {
      var $isMenu = _ref2.$isMenu;
      return $isMenu ? '5px 8px 5px 16px' : '5px 16px';
    }
  }
}), function (_ref3) {
  var $inline = _ref3.$inline,
      append = _ref3.append,
      prepend = _ref3.prepend;
  return !$inline && !append && !prepend && Object(external_styled_components_["css"])(["width:100%;"]);
}, function (_ref4) {
  var $isIconOnly = _ref4.$isIconOnly;
  return $isIconOnly && Object(external_styled_components_["css"])(["box-sizing:border-box;padding:", ";width:", ";min-width:", ";"], Object(themes_["pick"])({
    enterprise: {
      comfortable: '0 5px',
      compact: '0 2px'
    },
    prisma: {
      comfortable: Object(external_styled_components_["css"])(["0px calc(", " / 2 - 1px)"], themes_["variables"].inputHeight),
      compact: Object(external_styled_components_["css"])(["0px calc(", " / 2 - 1px)"], themes_["variables"].inputHeight)
    }
  }), themes_["variables"].inputHeight, themes_["variables"].inputHeight);
}, function (_ref5) {
  var $isIconOnly = _ref5.$isIconOnly;
  return $isIconOnly ? null : Object(external_styled_components_["css"])(["width:auto;"]);
}, function (_ref6) {
  var prepend = _ref6.prepend;
  return !prepend && Object(external_styled_components_["css"])(["margin-left:", ";"], Object(themes_["pick"])({
    enterprise: themes_["variables"].spacingHalf,
    prisma: themes_["variables"].spacingSmall
  }));
});
var StyledContentWrapper = external_styled_components_default.a.span.withConfig({
  displayName: "ButtonStyles__StyledContentWrapper",
  componentId: "eqxqs2-2"
})(["display:flex;flex-direction:row;justify-content:center;align-items:center;max-width:100%;padding:", ";"], Object(themes_["pick"])({
  enterprise: Object(themes_["pickVariant"])('$error', {
    "true": '1px',
    "false": Object(themes_["pickVariant"])('$appearance', {
      "default": '0',
      secondary: '0',
      destructive: '0',
      // === default
      primary: '1px',
      pill: '0',
      toggle: '0',
      // === default
      flat: '0' // === default

    })
  }),
  prisma: Object(themes_["pickVariant"])('$appearance', {
    "default": 0,
    secondary: '1px 0',
    primary: '1px 0',
    destructive: '1px 0',
    pill: '1px 0',
    // === secondary
    toggle: '0',
    flat: '1px 0'
  })
}));
var StyledLabel = external_styled_components_default.a.span.withConfig({
  displayName: "ButtonStyles__StyledLabel",
  componentId: "eqxqs2-3"
})(["text-overflow:ellipsis;overflow:hidden;flex:0 1 auto;&:not(:last-child){padding-right:", ";}", ""], Object(themes_["pick"])({
  enterprise: '3px',
  prisma: '10px'
}), function (_ref7) {
  var $isMenu = _ref7.$isMenu;
  return $isMenu && Object(external_styled_components_["css"])(["flex:1 1 auto;text-align:left;"]);
});
var StyledCaretWrapper = external_styled_components_default.a.span.withConfig({
  displayName: "ButtonStyles__StyledCaretWrapper",
  componentId: "eqxqs2-4"
})(["display:inline-flex;", ""], Object(themes_["pickVariant"])('$disabled', {
  "false": {
    prisma: Object(themes_["pickVariant"])('$primary', {
      "true": Object(external_styled_components_["css"])(["color:", ";"], themes_["variables"].contentColorInverted),
      "false": Object(external_styled_components_["css"])(["color:", ";", ":hover > * > &,", ":active > * > &,{color:", ";}"], themes_["variables"].contentColorDefault,
      /* sc-sel */
      StyledButtonSimple,
      /* sc-sel */
      StyledButtonSimple, themes_["variables"].contentColorDefault)
    })
  }
}));

// CONCATENATED MODULE: ./src/Button/Button.tsx
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function Button_extends() { Button_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Button_extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var propTypes = {
  action: external_prop_types_default.a.string,
  appearance: external_prop_types_default.a.oneOf(['default', 'secondary', 'primary', 'destructive', 'pill', 'toggle', 'flat']),
  append: external_prop_types_default.a.bool,
  children: external_prop_types_default.a.node,

  /** @private An additional className to add to the button. */
  classNamePrivate: external_prop_types_default.a.string,
  disabled: external_prop_types_default.a.bool,
  elementRef: external_prop_types_default.a.oneOfType([external_prop_types_default.a.func, external_prop_types_default.a.object]),
  error: external_prop_types_default.a.bool,
  icon: external_prop_types_default.a.node,
  inline: external_prop_types_default.a.bool,
  isMenu: external_prop_types_default.a.bool,
  label: external_prop_types_default.a.node,
  onClick: external_prop_types_default.a.func,
  openInNewContext: external_prop_types_default.a.bool,
  prepend: external_prop_types_default.a.bool,
  selected: external_prop_types_default.a.bool,
  to: external_prop_types_default.a.string,
  value: external_prop_types_default.a.any
};
var defaultProps = {
  appearance: 'default',
  append: false,
  disabled: false,
  error: false,
  inline: true,
  isMenu: false,
  openInNewContext: false,
  prepend: false,
  selected: false
};

var Button_Button = /*#__PURE__*/function (_Component) {
  _inherits(Button, _Component);

  var _super = _createSuper(Button);

  function Button() {
    var _this;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "component", null);

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      var _this$props = _this.props,
          label = _this$props.label,
          icon = _this$props.icon,
          value = _this$props.value,
          action = _this$props.action,
          onClick = _this$props.onClick;
      onClick === null || onClick === void 0 ? void 0 : onClick(e, {
        label: label,
        icon: icon,
        value: value,
        action: action
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMount", function (c) {
      _this.component = c;
    });

    return _this;
  }

  _createClass(Button, [{
    key: "focus",

    /**
     * Places focus on the button.
     */
    value: function focus() {
      var _this$component;

      (_this$component = this.component) === null || _this$component === void 0 ? void 0 : _this$component.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          action = _this$props2.action,
          appearance = _this$props2.appearance,
          append = _this$props2.append,
          className = _this$props2.className,
          classNamePrivate = _this$props2.classNamePrivate,
          disabled = _this$props2.disabled,
          error = _this$props2.error,
          icon = _this$props2.icon,
          inline = _this$props2.inline,
          isMenu = _this$props2.isMenu,
          onClick = _this$props2.onClick,
          openInNewContext = _this$props2.openInNewContext,
          prepend = _this$props2.prepend,
          to = _this$props2.to,
          value = _this$props2.value;
      var _this$props3 = this.props,
          children = _this$props3.children,
          label = _this$props3.label;

      if (!label && Object(external_lodash_["isString"])(children)) {
        label = children;
        children = null;
      }

      var isIconOnly = !!(icon && !label && !isMenu && !children);
      var hasPrismaIcon = to && openInNewContext || isMenu || !!icon;
      return /*#__PURE__*/external_react_default.a.createElement(StyledButtonSimple, Button_extends({
        "aria-haspopup": isMenu || undefined,
        "aria-invalid": error || undefined,
        "data-test": "button"
      }, this.props, {
        className: Object(style_["toClassName"])(className, classNamePrivate),
        "data-action": action,
        "data-inline": inline || null,
        disabled: disabled,
        append: append,
        prepend: prepend,
        $inline: inline,
        $hasPrismaIcon: hasPrismaIcon,
        $isIconOnly: isIconOnly,
        $isMenu: isMenu,
        status: error ? 'error' : 'normal' // @ts-expect-error - this is problematic for two reasons:
        // * value is only a valid attribute on button (not on a)
        // * this component's value prop is of type any, which can result
        //   in "[object Object]" attribute values
        ,
        value: value,
        onClick: onClick ? this.handleClick : undefined,
        ref: this.handleMount,
        openInNewContext: openInNewContext,
        appearance: appearance
      }), /*#__PURE__*/external_react_default.a.createElement(StyledContentWrapper, {
        $appearance: appearance,
        $error: error
      }, icon && /*#__PURE__*/external_react_default.a.createElement(StyledIcon, {
        $isIconOnly: isIconOnly
      }, icon), label && /*#__PURE__*/external_react_default.a.createElement(StyledLabel, {
        "data-test": "label",
        $isMenu: isMenu
      }, label), children, isMenu && /*#__PURE__*/external_react_default.a.createElement(StyledCaretWrapper, {
        $disabled: disabled,
        $primary: appearance === 'primary'
      }, /*#__PURE__*/external_react_default.a.createElement(CaretDown["a" /* default */], {
        enterpriseSize: 0.5
      })), openInNewContext && /*#__PURE__*/external_react_default.a.createElement(External, {
        screenReaderText: Object(i18n_["_"])('Open externally'),
        enterpriseSize: 0.8,
        style: {
          verticalAlign: 'baseline'
        }
      })));
    }
  }]);

  return Button;
}(external_react_["Component"]);

_defineProperty(Button_Button, "propTypes", propTypes);

_defineProperty(Button_Button, "defaultProps", defaultProps);

_defineProperty(Button_Button, Dropdown_["legacyRefMode"], true);

/* harmony default export */ var src_Button_Button = (Button_Button);
// CONCATENATED MODULE: ./src/Button/index.ts



/***/ }),

/***/ 19:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-ui/Dropdown");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CaretDown; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _splunk_react_icons_Caret__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37);
/* harmony import */ var _splunk_react_icons_Caret__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_splunk_react_icons_Caret__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ThemedIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }






function Prisma24(_ref) {
  var otherProps = _extends({}, _ref);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_SVG__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], _extends({
    viewBox: "0 0 24 24"
  }, otherProps), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
    d: "M7.2788 9.00002C6.84609 9.00002 6.61768 9.51239 6.90691 9.83423L11.4078 14.8426C11.6065 15.0637 11.953 15.0636 12.1517 14.8425L16.6499 9.8341C16.939 9.51223 16.7106 9 16.2779 9L7.2788 9.00002Z",
    fill: "currentColor"
  }));
}

function CaretDown(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_ThemedIcon__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"], _extends({
    Enterprise: _splunk_react_icons_Caret__WEBPACK_IMPORTED_MODULE_1___default.a,
    Prisma24: Prisma24
  }, props));
}

/***/ }),

/***/ 37:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-icons/Caret");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

module.exports = require("@splunk/ui-utils/style");

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-ui/ButtonSimple");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@splunk/ui-utils/i18n");

/***/ }),

/***/ 51:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-icons/External");

/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SVG; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_1__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Styled = styled_components__WEBPACK_IMPORTED_MODULE_1___default.a.svg.withConfig({
  displayName: "SVG__Styled",
  componentId: "sc-1bz0ryh-0"
})(["flex:0 0 auto;"]);
function SVG(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Styled, _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props));
}

/***/ }),

/***/ 7:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Icon; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _splunk_themes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
/* harmony import */ var _splunk_themes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_splunk_themes__WEBPACK_IMPORTED_MODULE_2__);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var inlineStyles = {
  display: 'inline-block',
  flex: '0 0 auto',
  overflow: 'visible',
  verticalAlign: 'middle'
};
var blockStyles = {
  display: 'block',
  flex: '0 0 auto',
  margin: '0 auto',
  overflow: 'visible'
};
var propTypes = {
  Enterprise: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  enterpriseSize: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string]),
  enterpriseWidth: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string]),
  enterpriseHeight: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string]),
  Prisma24: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func.isRequired,
  Prisma20: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  Prisma16: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  prismaSize: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['medium', 'small']),
  inline: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  screenReaderText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};
var defaultProps = {
  inline: true,
  prismaSize: 'medium'
};
function Icon(_ref) {
  var Enterprise = _ref.Enterprise,
      Prisma24 = _ref.Prisma24,
      Prisma20 = _ref.Prisma20,
      Prisma16 = _ref.Prisma16,
      prismaSize = _ref.prismaSize,
      inline = _ref.inline,
      enterpriseSize = _ref.enterpriseSize,
      enterpriseWidth = _ref.enterpriseWidth,
      enterpriseHeight = _ref.enterpriseHeight,
      screenReaderText = _ref.screenReaderText,
      otherProps = _objectWithoutProperties(_ref, ["Enterprise", "Prisma24", "Prisma20", "Prisma16", "prismaSize", "inline", "enterpriseSize", "enterpriseWidth", "enterpriseHeight", "screenReaderText"]);

  var _useSplunkTheme = Object(_splunk_themes__WEBPACK_IMPORTED_MODULE_2__["useSplunkTheme"])(),
      family = _useSplunkTheme.family,
      density = _useSplunkTheme.density; // Enterprise - all variants


  if (family === 'enterprise') {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Enterprise, _extends({
      size: enterpriseSize,
      width: enterpriseWidth,
      height: enterpriseHeight,
      screenReaderText: screenReaderText || null,
      hideDefaultTooltip: true,
      inline: inline
    }, otherProps));
  }

  var prismaProps = _objectSpread({
    'aria-label': screenReaderText,
    style: inline ? inlineStyles : blockStyles
  }, otherProps); // Prisma - small+compact, small+comfortable


  if (prismaSize === 'small') {
    var SVG = Prisma16 || Prisma24;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(SVG, _extends({
      width: "16",
      height: "16"
    }, prismaProps));
  } // Prisma - medium+compact


  if (density === 'compact') {
    var _SVG = Prisma20 || Prisma24;

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_SVG, _extends({
      width: "20",
      height: "20"
    }, prismaProps));
  } // Prisma - medium+comfortable


  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Prisma24, _extends({
    width: "24",
    height: "24"
  }, prismaProps));
}
Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;

/***/ })

/******/ });